<template>
  <div>
    <v-row class="ma-4">
      <b>Dados Técnicos do Módulo</b>
    </v-row>

    <v-row>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.dcPowerWp"
          label="Potência Dc (Wp)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.voc"
          label="Tensão Voc(V)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.vmp"
          label="Tensão Vmp(V)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.isc"
          label="Corrente Isc (A)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.imp"
          label="Corrente Imp (A)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.coefVoc"
          label="Coef. Voc (%/oC)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.coefVmp"
          label="Coef. Vmp (%/oC)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.coefIsc"
          label="Coef. Isc (%/oC)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.coefPmp"
          label="Coef. Pmax (%/oC)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.efficiency"
          label="Eficiência (%)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.weight"
          label="Peso (kg)"
          v-bind:options="optionsBr"
        />
      </v-col>
      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.height"
          label="Altura (mm)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.width"
          label="Largura (mm)"
          v-bind:options="optionsBr"
        />
      </v-col>

      <v-col cols="12" md="3">
        <vuetify-money
          v-model.number="device.depth"
          label="Profundidade (mm)"
          v-bind:options="optionsBr"
        />
      </v-col>
    </v-row>
    <br />
  </div>
</template>



<script>
export default {
  components: {
    // EditModulo
  },

  name: "edit-module",

  props: {
    tableHeaderColor: {
      type: String,
      default: "",
    },
  },
  props: ["device"],
  data() {
    return {
      selected: [],
      optionsBr: {
        locale: "pt-BR",
        prefix: "",
        suffix: "",
        precision: 2,
      },
    };
  },

  methods: {},
};
</script>
